import React from 'react';
import PropTypes from 'prop-types';
import './TabNavigation.css';

/**
 * TabNavigation Component
 * Horizontal tab navigation for Business sections
 *
 * @param {Array} tabs - Array of tab objects with { key, label, icon (optional), iconClass (optional), disabled (optional) }
 * @param {string} activeTab - Currently active tab key
 * @param {Function} onChange - Callback when tab is changed
 */
const TabNavigation = ({ tabs, activeTab, onChange }) => {
  const handleTabClick = (tabKey, disabled) => {
    if (!disabled && tabKey !== activeTab) {
      onChange(tabKey);
    }
  };

  return (
    <div className="tab-navigation">
      <div className="tab-navigation__container">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`tab-navigation__tab ${
              activeTab === tab.key ? 'tab-navigation__tab--active' : ''
            } ${tab.disabled ? 'tab-navigation__tab--disabled' : ''}`}
            onClick={() => handleTabClick(tab.key, tab.disabled)}
            disabled={tab.disabled}
            aria-selected={activeTab === tab.key}
            role="tab"
          >
            <span className="tab-navigation__label" style={{fontSize:'14px'}}>{tab.label}</span>
            {tab.badge && (
              <span className="tab-navigation__badge">{tab.badge}</span>
            )}
          </button>
        ))}
      </div>
      <div className="tab-navigation__underline" />
    </div>
  );
};

TabNavigation.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.node,
      iconClass: PropTypes.string,
      disabled: PropTypes.bool,
      badge: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TabNavigation;
